<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>

      <!-- 正文 -->
      <div class="zhengwen">
        <h1>关于办理利用未公开信息交易刑事案件适用法律若干问题的解释</h1>
        <div class="first">
          <p>（2018年9月10日最高人民法院审判委员会第1748次会议、2018年11月30日最高人民检察院第十三届检察委员会第十次会议通过，自2019年7月1日起施行）</p>
          <P>为依法惩治证券、期货犯罪，维护证券、期货市场管理秩序，促进证券、期货市场稳定健康发展，保护投资者合法权益，根据《中华人民共和国刑法》《中华人民共和国刑事诉讼法》的规定，现就办理利用未公开信息交易刑事案件适用法律的若干问题解释如下：</P>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
       <div class="xh"></div>

        <div class="second">
          <p>第一条 刑法第一百八十条第四款规定的“内幕信息以外的其他未公开的信息”，包括下列信息：</p>
          <p>（一）证券、期货的投资决策、交易执行信息；</p>

          <p>（二）证券持仓数量及变化、资金数量及变化、交易动向信息；</p>

          <p>（三）其他可能影响证券、期货交易活动的信息。</p>

          <p>第三条 刑法第一百八十条第四款规定的“违反规定”，是指违反法律、行政法规、部门规章、全国性行业规范有关证券、期货未公开信息保护的规定，以及行为人所在的金融机构有关信息保密、禁止交易、禁止利益输送等规定。</p>

          <p>（二）行为人获取未公开信息的初始时间与他人从事相关交易活动的初始时间具有关联性；</p>

          <p>（三）行为人与他人之间具有亲友关系、利益关联、交易终端关联等关联关系；</p>
          <p>特种设备生产、使用单位的主要负责人应当对本单位特种设备的安全和节能全面负责。</p>

          <p>（四）他人从事相关交易的证券、期货品种、交易时间与未公开信息所涉证券、期货品种、交易时间等方面基本一致；</p>

          <p>（五）他人从事的相关交易活动明显不具有符合交易习惯、专业判断等正当理由；</p>

          <p>（六）行为人对明示、暗示他人从事相关交易活动没有合理解释。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>